import type { SVGProps } from "react";
const SvgCarryOnBaggage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <defs>
      <radialGradient
        id="carryOnBaggage_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(1.3 0 0 1.3 21.34 28.208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.33} stopColor="#1F1F1F" />
        <stop offset={0.462} stopColor="#4D4D4D" />
        <stop offset={0.759} stopColor="#4D4D4D" />
        <stop offset={0.829} stopColor="#3B3B3B" />
        <stop offset={1} stopColor="#141414" />
      </radialGradient>
      <radialGradient
        id="carryOnBaggage_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(1.3 0 0 1.3 10.65 28.208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.33} stopColor="#1F1F1F" />
        <stop offset={0.462} stopColor="#4D4D4D" />
        <stop offset={0.759} stopColor="#4D4D4D" />
        <stop offset={0.829} stopColor="#3B3B3B" />
        <stop offset={1} stopColor="#141414" />
      </radialGradient>
      <radialGradient
        id="carryOnBaggage_svg__e"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(.2 7.9 -13.5 .4 16 19.5)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.63} stopColor="#2472BF" />
        <stop offset={1} stopColor="#11508F" />
      </radialGradient>
      <linearGradient
        id="carryOnBaggage_svg__b"
        x1={21.341}
        x2={21.341}
        y1={27.546}
        y2={28.114}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#141414" />
        <stop offset={1} stopColor="#141414" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="carryOnBaggage_svg__d"
        x1={10.649}
        x2={10.649}
        y1={27.546}
        y2={28.114}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#141414" />
        <stop offset={1} stopColor="#141414" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="carryOnBaggage_svg__f"
        x1={15}
        x2={21.317}
        y1={20.441}
        y2={20.441}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.084} stopColor="#fff" />
        <stop offset={0.097} stopColor="#E3E3E3" />
        <stop offset={0.188} stopColor="#fff" />
        <stop offset={0.2} stopColor="#E3E3E3" />
        <stop offset={0.202} stopColor="#E3E3E3" />
        <stop offset={0.446} stopColor="#fff" stopOpacity={0.973} />
        <stop offset={0.455} stopColor="#E3E3E3" />
        <stop offset={0.549} stopColor="#fff" />
        <stop offset={0.56} stopColor="#E3E3E3" />
        <stop offset={1} stopColor="#E3E3E3" />
      </linearGradient>
      <filter
        id="carryOnBaggage_svg__g"
        width={20.6}
        height={3.8}
        x={5.793}
        y={27.645}
        filterUnits="userSpaceOnUse"
      >
        <feGaussianBlur stdDeviation={0.75} />
      </filter>
    </defs>
    <path
      fill="#868686"
      d="M18.004 3.473h-4.011v12.112h-1.337V3.473c0-.738.599-1.336 1.337-1.336h4.01c.739 0 1.338.598 1.338 1.336v12.112h-1.337z"
    />
    <path
      fill="url(#carryOnBaggage_svg__a)"
      d="M21.34 29.545a1.337 1.337 0 1 0 0-2.674 1.337 1.337 0 0 0 0 2.674"
    />
    <path
      fill="url(#carryOnBaggage_svg__b)"
      d="M21.34 26.871c.74 0 1.338.598 1.338 1.337h-2.674c0-.739.598-1.337 1.337-1.337Z"
    />
    <path
      fill="url(#carryOnBaggage_svg__c)"
      d="M10.65 29.545a1.337 1.337 0 1 0 0-2.674 1.337 1.337 0 0 0 0 2.674"
    />
    <path
      fill="url(#carryOnBaggage_svg__d)"
      d="M10.65 26.871c.738 0 1.336.598 1.336 1.337H9.313c0-.739.599-1.337 1.338-1.337Z"
    />
    <path
      fill="url(#carryOnBaggage_svg__e)"
      d="M21.742 11.645H10.244a2.005 2.005 0 0 0-2.006 2.005v11.887c0 1.108.898 2.006 2.006 2.006h11.498a2.005 2.005 0 0 0 2.005-2.006V13.65a2.005 2.005 0 0 0-2.005-2.005"
    />
    <path
      fill="#6CA2D7"
      d="M13.729 13.848a.334.334 0 0 0-.334.334v10.825a.334.334 0 0 0 .668 0V14.182a.334.334 0 0 0-.334-.334m2.269 0a.334.334 0 0 0-.334.334v10.825a.334.334 0 0 0 .669 0V14.182a.334.334 0 0 0-.335-.334m2.266 0a.334.334 0 0 0-.334.334v10.825a.334.334 0 0 0 .668 0V14.182a.334.334 0 0 0-.334-.334"
      opacity={0.5}
    />
    <path
      fill="#1C1C1C"
      d="M19.337 4.142h-6.685v-.668c0-.739.599-1.337 1.337-1.337H18c.739 0 1.337.598 1.337 1.337z"
    />
    <path
      fill="url(#carryOnBaggage_svg__f)"
      d="M16.182 22.765s-.183-.548-.372-.72l-.81-2.15.822-.31s.19-.174.352-.23c.163-.054.336-.029.336-.029l1.34-.504.317-.216.325-.026.826-.419.116.027c.063.2.321.942.321.942l.782 2.077L20 21.5l-.28.16-.402.097-.806.345s-.167-.046-.345.028c-.179.074-.335.228-.335.228l-1.333.502c-.128-.054-.317-.095-.317-.095"
    />
    <g filter="url(#carryOnBaggage_svg__g)" opacity={0.5}>
      <ellipse cx={16} cy={29.544} fill="#000" rx={8.8} ry={0.4} />
    </g>
  </svg>
);
export default SvgCarryOnBaggage;
